import React from "react";
import { Navigate } from "react-router-dom";
import { adminAuth } from "@/lib/adminApi";

export default function ProtectedAdminRoute({ children }) {
  if (!adminAuth.isAuthenticated()) {
    return <Navigate to="/admin/login" replace />;
  }
  return children;
}
